module.exports = __webpack_public_path__ + "static/media/thread.469329f9.png";